module.exports = __webpack_public_path__ + "img/planted_c4_survival.7c6a59d6.svg";